import { createSelector } from '@reduxjs/toolkit';

const selectRoot = state => state?.ebpmsTrailers;

export const selectItems = createSelector(selectRoot, state => state?.items);
export const selectAllItems = createSelector(selectRoot, state => state?.allItems);
